import React from 'react';

import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Typography } from '@mui/material';

import RelatedListCard from '../RelatedListCard';
import RelatedTile from '../RelatedTile';
import RelatedTileGrid from '../RelatedTileGrid';
import { RELATED_PREVIEW_LIMIT, accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';

import { useAccountCases } from './useAccountCases';

interface Props {
  accountId: string;
}

export default function AccountCasesCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { cases, error, isLoading } = useAccountCases(accountId);

  return (
    <RelatedListCard
      count={cases.length}
      error={error}
      icon={<SupportAgentIcon color="action" />}
      isLoading={isLoading}
      isSampleData
      title="Cases"
      viewAllTo={accountPath(accountId, offerId, '/cases')}
    >
      <RelatedTileGrid>
        {cases.slice(0, RELATED_PREVIEW_LIMIT).map((accountCase) => (
          <RelatedTile
            key={accountCase.id}
            fields={[
              { label: 'Contact Name', value: accountCase.contactName },
              { label: 'Subject', value: accountCase.subject },
              { label: 'Priority', value: accountCase.priority },
            ]}
            heading={
              <Typography variant="subtitle1" component="h3">
                {accountCase.caseNumber}
              </Typography>
            }
          />
        ))}
      </RelatedTileGrid>
    </RelatedListCard>
  );
}
